class Scroll extends LibModule {
    DOMReady() {
        Scroll.scrollHighlight();
        $(window).on('hashchange', Scroll.scrollHighlight);

        let scrollOnPageload = $('[data-scroll-on-pageload]:first');
        if (scrollOnPageload.length) {
            Scroll.scrollToElement(scrollOnPageload);
        }
    }

    static scrollToElement(el, ignoreSticky) {

        if (!ignoreSticky && el.css('position') === 'sticky') {
            smoothScroll.animateScroll(document.body, null, {
                speed: 25,
                callback: function() {
                    Scroll.scrollToElement(el, true);
                }
            });
            return;
        }

        smoothScroll.animateScroll(el.get(0), null, {offset: el.data('scroll-and-highlight-offset') || 120});

    }

    static scrollHighlight() {
        let locHash = window.location.hash.substr(1);

        if (locHash && locHash.substr(0, 21) === 'scroll-and-highlight-') {
            let scrollTo = locHash.substr(21);
            let scrollToEl = $('[data-scroll-and-highlight=\'' + scrollTo + '\']');
            if (scrollToEl.length) {
                Scroll.scrollToElement(scrollToEl);
                Lib.Animation.blink(scrollToEl);
                Lib.Animation.blink(scrollToEl.find('*:not(.button)'));
            }
        }
    };

    onBottom(element, cb) {
        element.on('scroll', function() {

            var el = $(this);
            Lib.Debounce(function() {
                if (Math.abs(el[0].scrollHeight - el.scrollTop() - el.outerHeight()) <= 2) {
                    if (typeof cb === 'function') {
                        cb(el);
                    }
                }
            }, 50);

        });
    };

    offBottom(element) {
        element.off('scroll');
    };

}

Lib.Scroll = new Scroll;
